import type { Team, TeamSelection } from '../../types';
import { get, post, put, query, remove } from '../api';
import type { ProjectsFilter } from '../../../shared/projectsV2';

export const ADD_TEAM_PROJECTS = 'ADD_TEAM_PROJECTS';
export const REMOVE_TEAM_PROJECTS = 'REMOVE_TEAM_PROJECTS';
export const ADD_TEAM_USERS = 'ADD_TEAM_USERS';
export const REMOVE_TEAM_USERS = 'REMOVE_TEAM_USERS';
export const SET_TEAM_USER_ROLE = 'SET_TEAM_USER_ROLE';
export const ADD_TEAMS_ERROR = 'ADD_TEAMS_ERROR';
export const CLEAR_TEAMS_ERRORS = 'CLEAR_TEAMS_ERRORS';
export const ADD_TEAM_RELEASE_GROUPS = 'ADD_TEAM_RELEASE_GROUPS';
export const REMOVE_TEAM_RELEASE_GROUPS = 'REMOVE_TEAM_RELEASE_GROUPS';

export const FETCH_ONE_TEAM = 'FETCH_ONE_TEAM';
export const FETCH_ALL_TEAMS = 'FETCH_ALL_TEAMS';
export const UPDATE_TEAM = 'UPDATE_TEAM';
export const CREATE_TEAM = 'CREATE_TEAM';
export const DELETE_TEAM = 'DELETE_TEAM';
export const SET_TEAM_SELECTION = 'SET_TEAM_SELECTION';

const teamActions = {
  fetchOne: (teamId: number) => ({
    type: FETCH_ONE_TEAM,
    meta: {
      id: teamId,
    },
    async payload() {
      return get(`/api/teams/${teamId}`, true);
    },
  }),
  fetchAll: (filters?: object) => ({
    type: FETCH_ALL_TEAMS,
    async payload() {
      return get(`/api/teams`, true, filters);
    },
  }),

  create: (team: Team) => ({
    type: CREATE_TEAM,
    async payload() {
      return post(`/api/teams`, team);
    },
  }),

  update: (team: Team) => ({
    type: UPDATE_TEAM,
    meta: {
      id: team.id,
    },
    async payload() {
      return put(`/api/teams/${team.id}`, team);
    },
  }),

  delete: (teamId: number) => ({
    type: DELETE_TEAM,
    meta: {
      id: teamId,
    },
    async payload() {
      return remove(`/api/teams/${teamId}`);
    },
  }),
  addTeamProjects: (teamId: number | string, projectIds: string[] | 'all', filters?: ProjectsFilter) => ({
    type: ADD_TEAM_PROJECTS,
    async payload() {
      return put(`/api/teams/${teamId}/projects`, { projects: projectIds, action: 'add', filters });
    },
  }),
  removeTeamProjects: (teamId: number | string, projectIds: string[]) => ({
    type: REMOVE_TEAM_PROJECTS,
    meta: { projectIds },
    async payload() {
      return put(`/api/teams/${teamId}/projects`, { projects: projectIds, action: 'remove' });
    },
  }),
  addTeamUsers: (teamId: number | string, users: Array<{ id: number; roleId?: number }>) => ({
    type: ADD_TEAM_USERS,
    async payload() {
      return put(`/api/teams/${teamId}/users`, { users, action: 'add' });
    },
  }),
  removeTeamUsers: (teamId: number | string, users: Array<{ id: number }>) => ({
    type: REMOVE_TEAM_USERS,
    meta: { users },
    async payload() {
      return put(`/api/teams/${teamId}/users`, { users, action: 'remove' });
    },
  }),
  setTeamUserRole: (payload: { teamId: number; userId: number; roleId: number }) => ({
    type: SET_TEAM_USER_ROLE,
    payload,
  }),
  addError: (message: string) => ({
    type: ADD_TEAMS_ERROR,
    payload: message,
  }),
  clearErrors: () => ({
    type: CLEAR_TEAMS_ERRORS,
  }),
  addTeamReleaseGroups: (teamId: number | string, groupIds: number[]) => ({
    type: ADD_TEAM_RELEASE_GROUPS,
    async payload() {
      return post(`/api/teams/${teamId}/release-groups`, { ids: groupIds });
    },
  }),
  removeTeamReleaseGroups: (teamId: number | string, groupIds: number[]) => ({
    type: REMOVE_TEAM_RELEASE_GROUPS,
    meta: { groupIds },
    async payload() {
      return query(`/api/teams/${teamId}/release-groups`, {
        method: 'DELETE',
        body: { ids: groupIds },
        json: true,
      });
    },
  }),
  setTeamSelection: (selection: TeamSelection) => ({
    type: SET_TEAM_SELECTION,
    payload: selection,
  }),
};

export default teamActions;
